export default __webpack_public_path__ + "static/media/cherriesTtsIt_It60.2bd464ec.mp3";